import Vue from "vue";
import Vuex from "vuex";
import axios from "@/axios/axios";
import Storages from "@/utils/storages";
import home from './home.js';
import ctrl from './ctrl.js';
import fabricStore from './fabricjsStore/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userName: "",
        user: "",
        chatrs: {
            chartsList: 4,
        },
        sidebarItem: {
            items: "",
            meta: "",
            metas: "首页",
        },
        indexEchartsData: {},
        showHttpLoading: false,
        liveData: null, //首页报表动态更新
        layoutEditing: null, //首页布局开关 null, edit, saving, cancel
        requestHeaderToken: "",
        showCheckbox: false, //是否多选
        showProjectTree: true, //是否展示树
        year: [], //项目到当前年份数组
        auditYear: [], // 能源年份下拉数组
        allyear: [], //项目到当前年份数组
        Program: [], //所有项目
        Building: [], //建筑名称
        checkedProjectNumbers: [], //当前选中的项目编号数组
        checkProjectNodes:[],//当前选中的项目数据
        treeArray:[],
        treeNode:'',//存放当前所选区域
        cityName:'',
        returnFromProject:false,
        addrId:'',
		buildInfo: {},
		overview: {},
        indexTab:1,
        groupNumber:'G1',
        isLoading:false,//是否加载中 全局的
        showBtns:[],//当前页面权限
        curLeafMenus:[],
        curSideMenus:'',
        designContrl:'',
        airCollase:false,
        isStandard:false,
        showTimeContrl:false,
        showDebudMode:false,
        pageTitle:'',
        isDown:false,//单项目首页中间建筑模块是否根据实际大小伸缩
    },
    getters: {
         getLoading(state){
             return state.isLoading
         },
         getShowBtns(state){
             return state.showBtns
         },
         getIsDown(state){
            state.isDown=Storages.getLocalStorage("isDown")||false
            return state.isDown
         },
         //获取当选中项目编码集合
         getCheckedprojectNumbers: (state) => {
            if (
                !state.checkedProjectNumbers ||
                state.checkedProjectNumbers.length == 0
            ) {
                state.checkedProjectNumbers = Storages.getLocalStorage("$checkedProjectNumbers") || [];
            }
            return state.checkedProjectNumbers;
        },
         getAddrId: (state) => {
            if ( !state.addrId) {
                state.addrId = Storages.getLocalStorage("addrId") || [];
            }
            return state.addrId;
        },
        // 当前选中的项目节点
        getCheckedprojectObjs: (state) => {
            if (
                !state.checkProjectNodes ||
                state.checkProjectNodes.length == 0
            ) {
                state.checkProjectNodes =Storages.getLocalStorage("$checkProjectNodes") || [];
            }
            return state.checkProjectNodes;
        },
        getLoadingStatus(state) {
            return state.showHttpLoading;
        },
        getReturnFromProject(state) {
            state.returnFromProject=Storages.getLocalStorage("isRetrun")
            return state.returnFromProject;
        },
        getUploadHeader: (state) => {
            if (!state.requestHeaderToken) {
              state.requestHeaderToken = Storages.getLocalStorage("CHECKTOKEN");
            }
            return { token: state.requestHeaderToken,};
          },
        getRequestHeader(state) {
            return (
                state.requestHeaderToken ||
                Storages.getLocalStorage("CHECKTOKEN")
            );
        },
        getIndexEchartsData(state) {
            return state.indexEchartsData;
        },
        getYearArr(state) {
            return state.year;
        },
        getPageTitle(state) {
            return state.pageTitle;
        },
        getAllYearArr(state) {
            return state.allyear;
        },
        getAuditYearArr(state) {
            return state.auditYear;
        },
        getProjram(state) {
            return state.Program;
        },
        getBuilding(state) {
            return state.Building;
        },
        getControlTree(state) {
            if (!state.controlTree) {
                state.controlTree = Storages.getLocalStorage("$controlTree");
              }
              return state.controlTree
        },
        getUserLists(state) {
            if (!state.userList) {
                state.userList = Storages.getLocalStorage("$userList");
              }
              return state.userList
        },
        getTreeData(state){
            if (!state.treeArray) {
                state.treeArray = Storages.getLocalStorage("treeArray");
              }
              return state.treeArray
        },
        getTreeNode:(state)=>{
            return state.treeNode;
        },
        getCityName:(state)=>{
            return state.cityName;
        },
        getIndexTab: (state) => {
            return state.indexTab;
        },
        groupNumber(state){
            return state.groupNumber;
        },
        getCurLeafMenus: (state) => {
            if (!state.curLeafMenus||state.curLeafMenus.length==0) {
                state.curLeafMenus = Storages.getLocalStorage('curLeafMenus');
            }
            return state.curLeafMenus;
        },
        getCurSideMenus: (state) => {
            if (!state.curSideMenus) {
                state.curSideMenus = Storages.getLocalStorage('curSideMenus');
            }
            return state.curSideMenus;
        },
        getAirCollase: (state) => {
            if (!state.airCollase) {
                state.airCollase = Storages.getLocalStorage('airCollase');
            }
            return state.airCollase;
        },
        getAirStandard: (state) => {
            if (!state.isStandard) {
                state.isStandard = Storages.getLocalStorage('isStandard');
            }
            return state.isStandard;
        },
        getDesignContrlStatus:(state)=>{
            return state.designContrl;
        },
        getShowTimeContrl:(state)=>{
            return state.showTimeContrl;
        },
        getShowDebudMode:(state)=>{
            return state.showDebudMode;
        },
    },
    mutations: {
            //页面加载进度条控制
        updateIsLoadingStatus(state, payload) {
            state.isLoading = payload.isLoading;
        },
        updateTreeNode(state, data){
            state.treeNode = data;
        },
        updateCityName(state, data){
            state.cityName = data;
        },
        updateAddrId(state, data){
            state.addrId = data;
            Storages.setLocalStorage("addrId", data);
        },
        updateReturnFromProject(state, data){
            state.returnFromProject = data;
            Storages.setLocalStorage("isRetrun", data);
        },
         // 保存树下面选中的projectNumber
         updateCheckedProjectNumbers(state, data) {
            //  console.log(data,'徇众项目，45454')
            state.checkedProjectNumbers = data;
            if (
                // !state.projectNumber &&
                // !Storages.getLocalStorage('$projectNumber') &&
                data.length > 0
            ) {
                state.projectNumber = data[0];
                Storages.setLocalStorage("$checkedProjectNumbers", data);
                Storages.setLocalStorage("$projectNumber", data[0]);
            }
        },
        // 保存树下面的选中的node
        updateCheckedProjectObjs(state, data) {
            state.checkProjectNodes = data;
            console.log(data,'选中的数据')
            Storages.setLocalStorage("$checkProjectNodes", data);
        },
        setIndexEchartsData(state, data) {
            data.name &&
                data.data &&
                (state.indexEchartsData[data.name] = data.data);
        },
          //---- 末端监控时序控制与调试模式状态结束-------
        setDesignContrl(state,val){
            console.log( '%c -vuex-','color:#f36c69',val);
            state.designContrl=val
        },
        add(state) {
            state.chatrs.chartsList++;
        },
        updateLoadingStatus(state, status) {
            state.showHttpLoading = status;
        },
        updateIsDown(state,status){
            Storages.setLocalStorage("isDown",status)
            state.isDown=status
        },
        updateIndexTab(state, status) {
            console.log(status)
            state.indexTab = status;
        },
        liveDataUpdate(state, action) {
            state.liveData = action;
        },
        layoutEditSwitcher(state, action) {
            state.layoutEditing = action;
        },
        setRequestHeader(state, tokenString) {
            Storages.setLocalStorage("CHECKTOKEN", tokenString);
            state.requestHeaderToken = tokenString;
        },
        ctrlShowCheckbox(state, val) {
            state.showCheckbox = !!val;
        },
        showProjectTreeFun(state, val) {
            state.showProjectTree = !!val;
        },
        setAllYear(state, val) {
            state.allyear = val;
        },
        setYear(state, val) {
            state.year = val;
        },
        setAuditYear(state, val) {
            state.auditYear = val;
        },
        setProgram(state, val) {
            state.Program = val;
        },
        setBuilding(state, val) {
            state.Building = val;
        },
        setBtnsByIndex(state,val){//按钮权限
            state.showBtns = val;
            Storages.setLocalStorage('showBtns',val);
        },
         // 存下拉树数组数据
         setObjTree(state,val){
            Storages.setLocalStorage("treeArray", val);
            state.treeArray = val;
        },
        setCurLeafMenus(state,val){//当前页面下的子路由数组，用于权限和多tab切换
            state.curLeafMenus = val;
            Storages.setLocalStorage('curLeafMenus',val);
        },
        setCurSideMenus(state,val){//当前页面下的子路由数组，用于权限和多tab切换
            state.curSideMenus = val;
            Storages.setLocalStorage('curSideMenus',val);
        },
        setAirCollase(state,val){//记录空开是否点击批量控制
            state.airCollase = val;
            Storages.setLocalStorage('airCollase',val);
        },
        setAirStandard(state,val){//记录空开是否点击批量控制
            state.isStandard = val;
            Storages.setLocalStorage('isStandard',val);
        },
        setTimeContrl(state,val){
            state.showTimeContrl=val
          },
        setDebudMode(state,val){
            state.showDebudMode=val
          },
        setPageTitle(state,val){
            state.pageTitle=val
          },
        SET_BUILDINFO(state, info){
            let data = Object.assign({}, state.buildInfo, info)
            state.buildInfo = data
        },
        SET_OVERVIEW(state, info){
            let data = Object.assign({}, state.overview, info)
            state.overview = data
        },
    },
    actions: {
        liveUpdateAction({ commit }, data) {
            commit("liveDataUpdate", data);
        },
        layoutEditAction({ commit }, data) {
            commit("layoutEditSwitcher", data);
        },
        getYear(context) {
            axios
                .get("/api/common/getSysCfgInfo?type=SYSTEM")
                .then((res) => {
                    if (res.code == 200) {
                        if (res.data) {
                            let year = res.data.year;
                            let currentYear = new Date().getFullYear();
                            let data = [{ label: "全部", value: 0 }];
                            let yearArr = [];
                            for (
                                let i = 0, len = currentYear - year;
                                i <= len;
                                i++
                            ) {
                                let temp = { value: "", label: "" };
                                temp.value = year;
                                temp.label = year + "年";
                                data.push(temp);
                                yearArr.push(temp);
                                year++;
                            }
                            // console.log("this.yearArr",data)
                            context.commit("setYear", data);
                            context.commit("setAllYear", yearArr);
                        }
                    }
                });
        },
        getAuditYear(context) {
            // 获取设置审计年份
            axios
                .get("/api/auditInfo/getAuditYear")
                .then((res) => {
                    if (res.code == 200) {
                        let arr = (res.data || {}) || [];
                        let yearArr = arr.map((item) => {
                            return {
                                label: item.year + "年",
                                value: item.year,
                            };
                        });
                        yearArr.unshift({ label: "全部", value: "" });
                        context.commit("setAuditYear", yearArr);
                        return;
                    }else{
                        context.commit("setAuditYear", [
                            { label: "全部", value: '' },
                        ]);
                    }
                })
                .catch((_) => {
                    context.commit("setAuditYear", [
                        { label: "全部", value: '' },
                    ]);
                });
        },
        setBuildInfo({ commit }, info) {
            commit("SET_BUILDINFO", info);
        },
        setOverview({ commit }, info) {
            commit("SET_OVERVIEW", info);
        },
    },
    modules:{
      home,
      ctrl,
      fabricStore
    }
});
